<template>
  <div class="page container-fluid h-100">
    <div class="row no-gutters row-md-h-100" @contextmenu.prevent>
      <div
        class="spec-img news-list-img col-12 col-lg-4"
        v-bind:style="{ 'background-image': 'url(' + image + ')' }"
      >
        <img :src="image" class="img-responsive d-none">
      </div>
      <div class="spec-content col-12 col-lg-8">
        <div class="spec-nav page-nav row no-padding">
          <div class="col-6 text-left">
            <b-link
              :to="{ name: 'Aktualnosc', params: { name: article.next} }"
              v-if="article.next"
            >
              <font-awesome-icon icon="arrow-left"/>
            </b-link>
          </div>
          <div class="col-6 text-right">
            <b-link
              :to="{ name: 'Aktualnosc', params: { name: article.prev} }"
              v-if="article.prev"
            >
              <font-awesome-icon icon="arrow-right"/>
            </b-link>
          </div>
        </div>
        <div class="article-title">
            <span class="article-date">{{ article.date }}</span>
            <h1>{{name}}</h1>
            <div class="article-description" v-html="article.description" v-if="article.description">{{ article.description }}</div>
        </div>
        <div class="col no-padding article-content" v-html="article.content">{{ article.content }}</div>
        <b-link class="more" :to="{ name: 'Kontakt' }">
          Kontakt
          <font-awesome-icon
            icon="arrow-right"
            :style="{ 'margin-left': '2rem', 'color': '#292a2b' }"
          />
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "NewsList",
  data() {
    return {
      article: [],
      image: "/assets/przykladowy-post.jpg"
    };
  },
  created() {
      this.getArticle(this.$route.params.name);
  },
  methods: {
    getArticle(page) {
      axios.get(this.$store.state.apiUrl + 'articles/' + page).then((response) => {this.article = response.data; })
      .catch(error => { this.$store.commit('setError', true) })
    }
  },
  watch: {
    $route(to, from) {
      if(this.$route.params.name) {
      this.getArticle(this.$route.params.name);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.article-title {
    text-align:center;
    margin-bottom:4rem;
}
.article-title h1 {
    margin:2rem 0;
    font-size:4rem;
}
.article-title .article-description {
    font-weight:bold;
}
.article-content a {
  font-weight:bold;
}
</style>
<style scoped>
.page {
  padding: 0;
  margin: 0;
  overflow: hidden;
  min-height: 800px;
}
.spec-img {
  background-repeat: no-repeat;
  background-size: cover;
}
.spec-content {
  padding: 2rem 3rem;
}

@media (min-width: 960px) {
  .spec-content {
    padding: 4rem 5rem;
  }
  .spec-img {
    opacity: unset;
    background-position: top center;
  }
}
</style>
<style scoped>
.article {
  padding: 2rem 3rem;
}

@media (min-width: 960px) {
  .article {
    padding: 2rem 5rem;
  }
}
</style>